import { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18n-lite'

import useFetchYesObjects from './useFetchYesObjects'

export default function useYesObject({
  objectUUID,
  objectclassUUID,
  showLoading = false
}) {
  const { t } = useTranslation()

  const { yesObjects, isLoading, fetchYesObjects } = useFetchYesObjects()

  const yesObject = useMemo(() => yesObjects[0], [yesObjects])

  const filterBody = useMemo(
    () => ({
      query: {
        $and: [
          {
            'uuid.des': {
              $eq: objectUUID
            }
          }
        ]
      },
      objectclass: objectclassUUID,
      orderby: [],
      pagination: { limit: 1, offset: 0 }
    }),
    [objectUUID, objectclassUUID]
  )

  useEffect(() => {
    if (objectclassUUID && objectUUID) {
      fetchYesObjects({ filterBody, showLoading }).then((yesObjects) => {
        if (!yesObjects?.length) {
          console.log(t('error-message.object-not-found'), { type: 'error' })
        }
      })
    }
  }, [filterBody, showLoading, t, fetchYesObjects, objectclassUUID, objectUUID])

  return {
    yesObject,
    isLoading
  }
}
